const RequiredAsterisk = () => (
  <sup className="text-danger ms-1">
    <strong>*</strong>
  </sup>
);

export default RequiredAsterisk;
